// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BusinessTreeController from "./business_tree_controller"
application.register("business-tree", BusinessTreeController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import DashboardController from "./dashboard_controller"
application.register("dashboard", DashboardController)

import NavbarHamburgerController from "./navbar_hamburger_controller"
application.register("navbar-hamburger", NavbarHamburgerController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ToggleViewController from "./toggle_view_controller"
application.register("toggle-view", ToggleViewController)

import UsernameReservationController from "./username_reservation_controller"
application.register("username-reservation", UsernameReservationController)

import WysiwygController from "./wysiwyg_controller"
application.register("wysiwyg", WysiwygController)
